<template>
    <header class="app-header"
            v-observe-visibility="{callback: handleVisibilityChange}"
    >
        <div class="app-header__inner"
             :class="{
                shadow:!visible
            }"
        >
            <div class="container">
                <!-- Logo -->
                <router-link class="app-header__link" to="/">
                    <app-logo class="app-header__logo"/>
                    <!--                    <img v-show="theme==='light'" src="http://cdn.airfunc.com/d1639fbd2c7b48f3b670eadddb16112e">-->
                    <!--                    <img v-show="theme==='dark'" src="http://cdn.airfunc.com/cda300530f604c808696f7037e781a67">-->
                    <!--                    <h1 class="">AirFunc</h1>-->
                </router-link>
                <!-- Navigation -->
                <nav class="app-header__nav">
                    <ul class="app-header__nav-list">
                        <li class="app-header__nav-item" v-for="link in headerLinks" :key="link.slug">
                            <!-- 动态路由 -->
                            <router-link v-if="link.type==='dynamic'"
                                         class="app-header__nav-link"
                                         :class="{
                                            active:routeName===link.routeName
                                         }"
                                         :to="{ name: link.routeName, params: { section: link.slug } }">
                                {{link.name}}
                            </router-link>
                            <!-- 静态路由 -->
                            <router-link v-else-if="link.type === 'static'"
                                         class="app-header__nav-link "
                                         :class="{
                                            active:routeName===link.slug
                                         }"
                                         :to="{ name: link.slug }"
                            > {{link.name}}
                            </router-link>
                            <!-- 外部路由 -->
                            <a v-else-if="link.type === 'external'"
                               class="app-header__nav-link "
                               :key="link.href"
                               :href="link.href">
                                {{link.name}}
                            </a>
                        </li>
                    </ul>
                </nav>
                <!--  theme switch   -->
                <theme-switch class="app-header__theme-switch"
                              :mode="theme"
                              @change="handleThemeChange"/>
                <!-- Search -->
                <app-search @search="handleSearch"/>
                <!--                -->
            </div>
        </div>
    </header>
</template>

<script>
    import AppSearch from '../AppSearch'
    import ThemeSwitch from '../ThemeSwitch'
    import AppLogo from '@assets/svg/inline.logo.svg'

    import {THEME_LIST, HEADER_LINKS} from '@config'

    export default {
        name: "AppHeader",
        data() {
            return {
                headerLinks: HEADER_LINKS,
                query: '',
                theme: 'light',
                visible: true
            }
        },
        computed: {
            routeName() {
                const route = this.$route
                return route.name
            }
        },
        watch: {
            theme: {
                handler(val) {
                    const bodyElement = document.body
                    bodyElement.classList.remove('mode-dark')
                    bodyElement.classList.remove('mode-light')
                    bodyElement.classList.add(`mode-${val}`)
                },
                immediate: true
            }
        },
        beforeMount() {
            this.getTheme()
        },
        methods: {
            handleSearch(query) {
                this.$router.push({
                    name: 'search',
                    query: {
                        query
                    }
                })
            },
            handleThemeChange() {
                const {theme} = this
                this.theme = theme === 'dark' ? 'light' : 'dark'
                this.setTheme(this.theme)
            },
            /**
             * 获取主题
             */
            getTheme() {
                const theme = localStorage.getItem('app-theme')
                this.theme = THEME_LIST.indexOf(theme) > -1 ? theme : THEME_LIST[0]
            },
            setTheme(val) {
                localStorage.setItem('app-theme', val)
            },
            handleVisibilityChange(visible) {
                this.visible = visible
            }
        },
        components: {
            AppSearch,
            ThemeSwitch,
            AppLogo
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-header {
        height: $headerHeight;

        &__inner {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 999;
            height: $headerHeight;
            background-color: $backgroundColor;
            background-color: var(--backgroundColor);
            @include transition-colors;

            &.shadow {
                box-shadow: $box-shadow;
            }
        }

        .container {
            display: flex;
            align-items: center;
            height: 100%;
            padding-left: $paddingMD;
            padding-right: $paddingMD;
        }

        &__link {
            margin-right: auto;
            height: 40px;
        }

        &__logo {
            height: 40px;
        }

        &__nav {
            margin-left: auto;
            margin-right: auto;
        }

        &__nav-list {
            display: flex;
        }

        &__nav-link {
            font-size: $fontSize;
            color: $textColor;
            color: var(--textColor);
            padding-left: $paddingMD;
            padding-right: $paddingMD;
            @include transition-colors;

            &.active,
            &:hover {
                color: $primaryColor;
                color: var(--primaryColor);
            }
        }

        &__theme-switch {
            margin-right: $paddingMD;
        }
    }

    @media (max-width: 860px) {
        .app-header {
            &__nav {
                display: none;
            }
        }
    }
    
    @media (min-width: 860px) and (max-width: 1280px) {
       .app-header{
           .container{
               width: 100%;
               max-width: 100%;
           }
       }
    }


</style>